import React, { useEffect, useState } from 'react'
import { message, Tooltip } from 'antd'
import classNames from 'classnames'
import moment from 'moment'
import { cloneDeep } from 'lodash-es'
import Button from '../../../baseComponent/button'
import util from '../../../utils/util'
import request from '../../../utils/request'
import Icon from '../../icon'
import Modal from '../../modal'
import Input from '../../../baseComponent/input'
import InputNumber from '../../filter2/inputNumber'
import DatePicker2 from '../../filter2/datePicker2'
import GenderAndCategory2 from '../../filter2/genderAndCategory2'
import ModalConfirm from '../../modal/modalConfirm'
import Select from '../../filter2/select'
import './index.less'

// type create 新建 edit 编辑 inspirationCreate 创建灵感集确定

const ChooseStyleTaskModal = ({
  visible,
  setVisible,
  inspirationName,
  onChange,
  type = 'create',
  onOk,
  onClose,
  taskItem,
  inspirationId
}) => {
  const [styleTaskData, setStyleTaskData] = useState({
    missionName: '',
    startTime: '',
    endTime: '',
    missionTargetList: [{ category: null, rootCategory: null, gender: null, targetNum: null, targetUserIdList: [] }]
  })
  const [isRules, setIsRules] = useState(false)

  useEffect(() => {
    if (taskItem && JSON.stringify(taskItem) !== '{}') {
      const _taskItem = cloneDeep(taskItem)
      _taskItem.startTime = moment(_taskItem.startTime).format('YYYY-MM-DD')
      _taskItem.endTime = moment(_taskItem.endTime).format('YYYY-MM-DD')
      setStyleTaskData(_taskItem)
    }
  }, [taskItem])

  const _onChange = (val) => {
    setStyleTaskData(pre => ({ ...pre, ...val }))
    onChange?.()
  }

  const onSubmit = async () => {
    setIsRules(true)
    if (styleTaskData.missionName
      && styleTaskData.startTime && styleTaskData.missionTargetList.every(item => item.gender && item.targetNum)) {
      const success = await request.post('/zhikuan/ins/blog/mission/save-or-update-mission', { inspirationId, ...styleTaskData })
      if (success) {
        message.success('保存成功')
        setVisible(false)
        util.track('mn-add-choose-style-task', {})
        onOk?.(styleTaskData)
      }
    } else {
      message.error('请输入必填项')
    }
  }
  const typeEnum = {
    inspirationCreate: '创建成功！给灵感集创建第一个选款任务吧',
    create: '新建选款任务',
    edit: '编辑选款任务'
  }
  const _jump = () => {
    onClose?.()
    setVisible(false)
  }
  return (<Modal
    title={<div className="choose-style-task-modal-title">{typeEnum[type] || typeEnum.create}</div>}
    className="choose-style-task-modal"
    visible={visible}
    onClose={_jump}
    // onVisibleChange={_visible => setVisible(_visible)}
    style={{ width: '640px' }}
    footer={<div className="choose-style-task-modal-footer">
      <Button
        type="normal"
        style={{ marginRight: 8, width: 74 }}
        onClick={_jump}
      >{type === 'inspirationCreate' ? '跳过' : '取消'}</Button>
      <Button type="primary" style={{ width: 74 }} onClick={onSubmit}>确定</Button>
    </div>}
  >
    <ChooseStyleTask
      type={type}
      style={{ marginTop: 16 }}
      isRules={isRules}
      inspirationName={inspirationName}
      value={styleTaskData}
      inspirationId={inspirationId}
      missionStatus={taskItem?.missionStatus}
      onChange={_onChange}
    />
  </Modal>)
}

const convert = (result) => {
  return result.map(m => ({ label: m.nickName, value: m.userId, ...m }))
}

const ChooseStyleTask = ({ value = {}, type, isRules, style, missionStatus = 'not_start', inspirationId, inspirationName, onChange }) => {
  const [memberOption, setMemberOption] = useState([])

  useEffect(() => {
    fetchMemberOption()
  }, [])

  const fetchMemberOption = async () => {
    const res = await request.get('/zhikuan/ins/inspiration/auth/cooperation-user-list', { params: { inspirationId } })
    setMemberOption(convert(res).filter(item => item.role === 1 || item.role === 2 || item.role === 3))
  }

  const handleChange = (val) => {
    onChange({ ...value, ...val })
  }
  const onChangeCategory = (index, val) => {
    const { missionTargetList = [] } = value
    missionTargetList[index] = { ...missionTargetList[index], ...val }
    onChange({ ...value })
  }
  const addCategory = () => {
    const { missionTargetList } = value
    missionTargetList.push({ category: null, targetNum: null, targetUserIdList: [] })
    onChange({ ...value })
  }

  const deleteCategory = (index, v) => {
    const { missionTargetList } = value
    if (v.id) {
      ModalConfirm.show({
        title: '删除任务目标',
        content: '是否删除该任务目标？',
        onOk: async () => {
          missionTargetList.splice(index, 1)
          onChange({ ...value })
        },
      })
    } else {
      missionTargetList.splice(index, 1)
      onChange({ ...value })
    }
  }

  return (<div className="choose-style-task" style={style}>
    <div className="choose-style-task-header">
      {type === 'inspirationCreate' && <div className="choose-style-task-text">新建选款任务</div>}
      <div className="choose-style-task-tip">
        <div className="choose-style-task-tip-line" />
        <div style={{ marginLeft: '12px' }}>
          <span style={{ color: 'var(--m-text-3)' }}>采集至</span>
          <span style={{ color: 'var(--m-text-1)', marginLeft: '8px' }}>{inspirationName}</span>
        </div>
      </div>
    </div>
    <div className={classNames('item-title', { required: isRules && !value.missionName })}>任务名称</div>
    <Input
      wrapClassName={classNames('item-input', { required: isRules && !value.missionName })}
      maxLength={20}
      value={value.missionName}
      placeholder="点击输入"
      onChange={(e) => { const missionName = e.target.value; handleChange({ missionName }) }}
      suffix={`${value?.missionName?.length || 0}/20`}
    />
    <div className={classNames('item-title')}>任务周期</div>
    <DatePicker2
      showTime
      startTime={value.startTime}
      endTime={value.endTime}
      noneText="不限"
      style={{ flex: '1' }}
      allowClear={!(missionStatus !== 'not_start')}
      required={isRules && !value.startTime}
      ranges={missionStatus !== 'not_start' ? [] : [{ name: '7天', value: [moment(), moment().add(7, 'd').subtract(1, 'd')] },
        { name: '15天', value: [moment(), moment().add(15, 'd').subtract(1, 'd')] },
        { name: '30天', value: [moment(), moment().add(30, 'd').subtract(1, 'd')] },
      ]}
      overlayStyle={{ minWidth: 'unset' }}
      rangeLeftConfig={{ disabled: missionStatus !== 'not_start' }}
      earlistDate={moment().format('YYYY-MM-DD')}
      getPopupContainer={() => document.querySelector('.choose-style-task-modal')}
      onChange={([startTime, endTime]) => {
        handleChange({ startTime, endTime })
      }}
    />
    <div className={classNames('item-title')}>任务目标</div>
    <div className="target-category">
      {value?.missionTargetList?.map((v, i) => (
        <div className="target-category-item-wrap">
          <div className="target-category-item" key={i}>
            <div className="target-category-item-title">任务{i + 1 / 10 > 0 ? `0${i + 1}` : i}</div>
            <div className="target-category-item-content">
              <div className="category-item-left">
                <div className={classNames('title')}>品类</div>
                <GenderAndCategory2
                  trigger={['click']}
                  gender={v.gender}
                  disabled={missionStatus !== 'not_start'}
                  displayClassName={classNames('category-item-select', { required: isRules && !v.gender })}
                  category={v.category || v.rootCategory}
                  onClear={() => onChangeCategory(i, { category: null, rootCategory: null, gender: null })}
                  onChange={(gender, rootCategory, category) => {
                    if (category) {
                      onChangeCategory(i, { category: rootCategory, rootCategory: category, gender })
                      return
                    }
                    onChangeCategory(i, { category, rootCategory, gender })
                  }}
                />
              </div>
              <div className="category-item-right" style={{ width: '152px' }}>
                <div className={classNames('title')}>目标数量</div>
                <InputNumber
                  className={classNames('item-input', { required: isRules && !v.targetNum })}
                  value={v?.targetNum}
                  max={2000}
                  disabled={missionStatus !== 'not_start'}
                  placeholder="请输入一个正整数"
                  onChange={val => onChangeCategory(i, { targetNum: val })}
                />
              </div>
              <div className="category-item-right">
                <div className={classNames('title-name')}>指定成员</div>
                <Select
                  className={classNames('item-input')}
                  multi
                  disabled={missionStatus !== 'not_start'}
                  trigger={['click']}
                  placeholder="不限"
                  data={memberOption}
                  container={document.querySelector('.choose-style-task')}
                  value={v?.targetUserIdList}
                  onClear={() => onChangeCategory(i, { targetUserIdList: null })}
                  onChange={val => onChangeCategory(i, { targetUserIdList: val })}
                />
              </div>
            </div>
          </div>
          {value?.missionTargetList?.length > 1 && !(missionStatus !== 'not_start') ? <div className="category-item-delete" onClick={() => deleteCategory(i, v)}>
            <Tooltip color="#181818" title="删除">
              <Icon type="m-jianshao_miaobian" className="mnjianshaoalt" />
            </Tooltip>
          </div> : null}
        </div>
      ))}
      {value?.missionTargetList?.length < 20 && !(missionStatus !== 'not_start')
        ? <div className={classNames('add-category')}>
          <span onClick={addCategory}><Icon type="m-tianjia_miaobian" className="mnxinzengalt" /><span>增加目标品类</span></span>
        </div>
        : null }
    </div>
  </div>)
}

export default ChooseStyleTaskModal
